import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
}), 'SchoolSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SchoolSharp.js
// module id = 5911
// module chunks = 2